import React, { useState } from "react";
import { Link } from 'react-router-dom'
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import Newsletter from "../../Components/Newsletter";
import UserSideBar from "./Components/Sidebar";
import {
    UserAppointmentLgImg3
} from "../../Constant/Index";
const AppointmentDetailsUser = () => {

    return (
        <>
            <Header />
            <UniversalBanner heading="My Profile" />
            <section className="profile-main">
                <div className="container">
                    <div className="profile-start">
                        <div className="row">
                            <UserSideBar />
                            <div className="col-lg-9 col-md-8">
                                <div className="profile-box">
                                    <div className="top-heading d-flex gap-4 align-items-center pb-4">
                                        <h3 className="md-heading min-width-fit mb-0">Appointment Details</h3>
                                        <hr className="w-100" />
                                    </div>
                                    <div className="detail-box">
                                        <div className="main-detail pb-3">
                                            <div className="row">
                                                <div className="col-md-8 pe-xl-4">
                                                    <div className="text-here">
                                                        <h5 className="xs-heading">Child Psychotherapy</h5>
                                                        <p className="text mb-0">We understand that seeking help for mental health issues can be intimidating, and that is why we strive to create a welcoming and non-judgmental atmosphere where clients feel comfortable and supported. Whether you are struggling with anxiety, depression, trauma, or any other mental health concern, we are here to provide you with the tools and support you need to move forward and lead a fulfilling, meaningful life</p>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 pt-4 pt-sm-0 mt-3 mt-sm-0">
                                                    <figure className="details-image">
                                                        <img src={UserAppointmentLgImg3} alt="" className="image-here w-100" />
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="detail-date d-sm-flex justify-content-between align-items-center">
                                            <div className="time-date p-0">
                                                <div className="appointment-time">
                                                    <span className="date-svg">
                                                        <svg width="15" height="16" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M11.75 2.66634V0.833008M11.75 2.66634V4.49967M11.75 2.66634H7.625M0.75 8.16634V16.4163C0.75 16.9026 0.943154 17.3689 1.28697 17.7127C1.63079 18.0565 2.0971 18.2497 2.58333 18.2497H15.4167C15.9029 18.2497 16.3692 18.0565 16.713 17.7127C17.0568 17.3689 17.25 16.9026 17.25 16.4163V8.16634M0.75 8.16634H17.25M0.75 8.16634V4.49967C0.75 4.01344 0.943154 3.54713 1.28697 3.20331C1.63079 2.8595 2.0971 2.66634 2.58333 2.66634H4.41667M17.25 8.16634V4.49967C17.25 4.01344 17.0568 3.54713 16.713 3.20331C16.3692 2.8595 15.9029 2.66634 15.4167 2.66634H14.9583M4.41667 0.833008V4.49967" stroke="#01323B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </span>
                                                    <span className="text">12, Dec,2023</span>
                                                </div>
                                                <div className="appointment-date">
                                                    <span className="time-svg">
                                                        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10 4.59961V9.99961H15.4" stroke="#01323B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M10 19C14.9707 19 19 14.9707 19 10C19 5.0293 14.9707 1 10 1C5.0293 1 1 5.0293 1 10C1 14.9707 5.0293 19 10 19Z" stroke="#01323B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </span>
                                                    <span className="text">4:30 PM</span>
                                                </div>
                                            </div>
                                            <button className="secondary-btn secondary-btn ms-sm-auto d-block d-block ">Join The Zoom Call</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Newsletter />
            <Footer />
        </>
    )
}
export default AppointmentDetailsUser;